// extracted by mini-css-extract-plugin
export default {"loader":"NAjjv","--overlay":"oN3r3","icon-v2":"PlXZ6","l20-1":"neCTW","l20-2":"Pr_Le"};